import { createQueryKeys } from '@/lib/utils';

export const offerKeys = createQueryKeys({
  userOffersRequest: 'userOffersRequest',
  storeOffersRequest: 'storeOffersRequest',
});
